import { render, staticRenderFns } from "./PaperDetail.vue?vue&type=template&id=8da88df4&scoped=true&"
import script from "./PaperDetail.vue?vue&type=script&lang=js&"
export * from "./PaperDetail.vue?vue&type=script&lang=js&"
import style0 from "./PaperDetail.vue?vue&type=style&index=0&id=8da88df4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8da88df4",
  null
  
)

export default component.exports